import AddNewLocationModal from './AddNewLocationModal';
import { useLocationSelectorContext } from './LocationSelectorContext';
import LocationSelectorModal from './LocationSelectorModal';
import UserLocationsRemovalModal from './UserLocationsRemovalModal';

const LocationSelectorModals = () => {
  const {
    isChangeLocationModalOpen,
    isAddNewLocationModalOpen,
    isRemoveLocationModalOpen,
  } = useLocationSelectorContext();

  return (
    <>
      {isChangeLocationModalOpen && <LocationSelectorModal />}

      {isAddNewLocationModalOpen && <AddNewLocationModal />}

      {isRemoveLocationModalOpen && <UserLocationsRemovalModal />}
    </>
  );
};

export default LocationSelectorModals;
